<template>
    <b-nav-item :to="{ name: 'issues', query: { status:'open' } }">
        <fa icon="clipboard-list" />
        {{ $t('Issues') }}

        <b-badge v-if="count" variant="danger">
            {{ count }}
        </b-badge>
    </b-nav-item>
</template>
<script>
    import {STATUS_OPEN} from "@/constants/issues";

    export default {
        name: 'IssuesNavItem',
        data() {
            return {
                count: 0
            }
        },
        created() {
            this.fetchData();

            this.$echo.listen('issues', 'IssueResolved', this.fetchData);
            this.$echo.listen('issues', '.created', this.fetchData);
            this.$echo.listen('issues', '.updated', this.fetchData);
        },
        methods: {
            fetchData() {
                this.axios.get('/api/issues', {
                    params: {
                        status: STATUS_OPEN,
                        count: 1
                    }
                }).then(({data}) => {
                    this.count = data;
                });
            },
        }
    }
</script>
